import styles from '@salesforce/retail-react-app/app/theme/components/project/social-icons';

export default {
  ...styles,

  baseStyle: {
    ...styles.baseStyle,

    container: {
      ...styles.baseStyle.container,

      gap: 4,
    },
    icon: {},
    item: {
      flexShrink: 0,
      height: 6,
      minWidth: 'auto',
      padding: 0,
      textAlign: 'center',
      width: 6,
      _hover: {
        color: 'whiteAlpha.800',
        transform: 'scale(1.1)',
      },
      _active: {
        transform: 'scale(0.95)',
      },
      transition: 'all 0.2s ease-in-out',
    },
  },
};
